import { render, staticRenderFns } from "./gonggaolist.vue?vue&type=template&id=0c06f3d4&scoped=true&"
import script from "./gonggaolist.vue?vue&type=script&lang=js&"
export * from "./gonggaolist.vue?vue&type=script&lang=js&"
import style0 from "./gonggaolist.vue?vue&type=style&index=0&id=0c06f3d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06f3d4",
  null
  
)

export default component.exports